import {FormikValues, useFormikContext} from 'formik'
import React from 'react'

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  name: string
  label?: string
}

const TextInput = (props: TextInputProps) => {
  const {className = '', name, label, ...rest} = props
  const {values, handleChange, handleBlur, errors, touched} = useFormikContext<FormikValues>()

  const typedValues = values as Record<string, any>

  return (
    <>
      {label && <div className='mb-1 fw-bold'><label htmlFor={name}>{label}</label></div>}
      <input
        type='text'
        className={`form-control ${className} ${touched[name] && errors[name] ? 'is-invalid' : ''}`}
        name={name}
        value={typedValues[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        {...rest}
      />
      {touched[name] && errors[name] && (
        <div className="text-danger mt-1 fw-bold" style={{ fontSize: '0.9em' }}>
          {errors[name] as any}
        </div>
      )}
    </>
  )
}

export default TextInput
